"use client";

import React, { useState } from "react";
import { ArrowRight, ChevronsLeftRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const galleryProjects = [{
  id: "proj-1",
  title: "Trex Transcend Havana Gold",
  location: "San Francisco, CA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/night_pathway_lighting_1.png",
  spanClasses: "md:col-span-4 row-span-2"
}, {
  id: "proj-2",
  title: "Multi-Level Composite Oasis",
  location: "Santa Clara, CA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/night_facade_lighting_1.png",
  spanClasses: "md:col-span-4 row-span-1"
}, {
  id: "proj-3",
  title: "Spiced Rum Pool Decking",
  location: "Santa Cruz, CA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/night_pool_lighting_1.png",
  spanClasses: "md:col-span-4 row-span-2"
}, {
  id: "proj-4",
  title: "Trex Enhance Rocky Harbor",
  location: "Monterey, CA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/night_garden_lighting_1.png",
  spanClasses: "md:col-span-4 row-span-1"
}];
const beforeAfterData = {
  title: "Old Wood to Modern Composite",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/dark_backyard_before.png",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/illuminated_backyard_after.png"
};
function BeforeAfterSlider({
  beforeImg,
  afterImg,
  title
}: {
  beforeImg: string;
  afterImg: string;
  title: string;
}) {
  const [sliderPos, setSliderPos] = useState(50);
  return <div data-section-id="137824" className="relative w-full h-full overflow-hidden rounded-lg group shadow-2xl shadow-secondary/10">
      {}
      <img src={afterImg} alt={`${title} After`} className="absolute inset-0 w-full h-full object-cover" />

      {}
      <div className="absolute inset-0 w-full h-full overflow-hidden" style={{
      clipPath: `polygon(0 0, ${sliderPos}% 0, ${sliderPos}% 100%, 0 100%)`
    }}>
        <img src={beforeImg} alt={`${title} Before`} className="absolute inset-0 w-full h-full object-cover" />
      </div>

      {}
      <div className="absolute top-0 bottom-0 w-1 bg-white z-10 pointer-events-none" style={{
      left: `${sliderPos}%`
    }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center transition-transform group-hover:scale-110">
          <ChevronsLeftRight className="w-6 h-6 text-primary" />
        </div>
      </div>

      {}
      <input type="range" min="0" max="100" value={sliderPos} onChange={e => setSliderPos(Number(e.target.value))} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-20" aria-label="Toggle before and after view" />

      {}
      <div className="absolute top-6 left-6 bg-black/40 backdrop-blur-md text-white px-4 py-1.5 rounded-lg text-sm font-default z-10 pointer-events-none border border-white/10 shadow-sm">
        Before
      </div>
      <div className="absolute top-6 right-6 bg-black/40 backdrop-blur-md text-white px-4 py-1.5 rounded-lg text-sm font-default z-10 pointer-events-none border border-white/10 shadow-sm">
        After
      </div>
      
      {}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-black/60 backdrop-blur-md text-white px-6 py-2 rounded-lg text-sm font-default z-10 pointer-events-none border border-white/10 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-2">
        <Sparkles className="w-4 h-4 text-primary" />
        Drag to reveal transformation
      </div>
    </div>;
}
export default function LightingProjectGallery() {
  return <section id="portfolio-composite-trex-deck-projects" className="relative bg-background overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-[10%] -left-[5%] w-[40%] h-[40%] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/blurred_greenery_1.png)] bg-contain bg-no-repeat opacity-20 blur-sm animate-[pulse_8s_ease-in-out_infinite]" />
        <div className="absolute top-[40%] -right-[10%] w-[50%] h-[50%] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/blurred_greenery_2.png)] bg-contain bg-no-repeat opacity-15 blur-md animate-[pulse_12s_ease-in-out_infinite_reverse]" />
        <div className="absolute -bottom-[10%] left-[20%] w-[30%] h-[30%] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/blurred_greenery_3.png)] bg-contain bg-no-repeat opacity-20 blur-sm animate-[pulse_10s_ease-in-out_infinite]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        {}
        <div className="max-w-3xl mx-auto text-center mb-16 lg:mb-24">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 tracking-tight">
            Composite Deck <span className="text-primary italic">Mastery</span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default">
            View our portfolio of premium Trex and composite deck installations across Northern California. 
            We combine structural integrity with high-performance, low-maintenance materials for your home.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 auto-rows-[300px] md:auto-rows-[350px]">
          
          {}
          <div className={galleryProjects[0].spanClasses} data-index={0}>
            <div className="group relative w-full h-full overflow-hidden rounded-lg shadow-lg">
              <img src={galleryProjects[0].image} alt={galleryProjects[0].title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
              
              {}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 backdrop-blur-md bg-black/30 transition-all duration-500 flex flex-col justify-end p-8 border border-white/10 rounded-lg">
                <h3 className="font-default text-2xl md:text-3xl font-bold text-white translate-y-4 group-hover:translate-y-0 transition-transform duration-500 ease-out">
                  {galleryProjects[0].title}
                </h3>
                <p className="text-white/80 mt-2 font-default translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-75 ease-out flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                  {galleryProjects[0].location}
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="md:col-span-8 row-span-2" data-index="slider">
            <BeforeAfterSlider beforeImg={beforeAfterData.beforeImage} afterImg={beforeAfterData.afterImage} title={beforeAfterData.title} />
          </div>

          {}
          {galleryProjects.slice(1).map((project, i) => <div key={project.id} className={project.spanClasses} data-index={i + 1}>
              <div className="group relative w-full h-full overflow-hidden rounded-lg shadow-lg">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
                
                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 backdrop-blur-md bg-black/30 transition-all duration-500 flex flex-col justify-end p-8 border border-white/10 rounded-lg">
                  <h3 className="font-default text-2xl font-bold text-white translate-y-4 group-hover:translate-y-0 transition-transform duration-500 ease-out">
                    {project.title}
                  </h3>
                  <p className="text-white/80 mt-2 font-default translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-75 ease-out flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                    {project.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-16 text-center flex justify-center">
          <Button asChild size="lg" className="rounded-lg px-8 h-14 text-base font-default shadow-xl shadow-secondary/20 hover:shadow-secondary/40 transition-all duration-300">
            <Link to="#">
              View Full Gallery
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}